import React, { useEffect } from "react";
import { HiCheckCircle, HiExclamationTriangle } from "react-icons/hi2";

type ToastType = "success" | "warning" | "error" | "info";

interface ToastProps {
  open: boolean;
  type?: ToastType;
  message: string;
  onClose?: () => void;
}

const Toast: React.FC<ToastProps> = ({ open, type = "success", message, onClose }) => {
  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(() => onClose?.(), 3000);
    return () => clearTimeout(timer);
  }, [open, onClose]);

  if (!open) return null;

  const Icon = type === "success" ? HiCheckCircle : HiExclamationTriangle;

  const bgColor =
    type === "success"
      ? "bg-green-600"
      : type === "error"
      ? "bg-red-600"
      : type === "warning"
      ? "bg-yellow-600"
      : "bg-blue-600";

  return (
    <div
      className={`fixed inset-x-4 bottom-4 sm:inset-x-auto sm:left-1/2 sm:bottom-6 sm:-translate-x-1/2 sm:w-auto sm:max-w-md px-4 py-3 rounded-xl shadow-lg flex items-start gap-3 text-sm font-medium z-[1000] text-white ${bgColor}`}
    >
      <Icon size={20} className="shrink-0 mt-0.5" />
      <span>{message}</span>
    </div>
  );
};

export default Toast;
